import ServiceDetail from "@/components/ServiceDetail";
import { SERVICES_DATA } from "@/data/services";
import { GALLERY_ITEMS } from "@/data/gallery";

export default function Renovations() {
    const projects = GALLERY_ITEMS.filter((g) => g.category === "renovations");
    return <ServiceDetail data={SERVICES_DATA.renovations} projects={projects} />;
}
